import { readChromeModelClientDatabase } from '.';
import { getOwnerID } from '../../utils/DryCookies';
import logger from '../../logger';
import { HasChromeModelsLocalDatabaseContentType } from '../../types/chromeModels';

export const checkChromeModelsLocalDatabaseContent = async () => {
  console.log('hasChromeModelsLocalDatabaseContent');
  const ownerId = getOwnerID() as string;
  let hasChromeModelsLocalDatabaseContent = false as HasChromeModelsLocalDatabaseContentType;
  if (!ownerId) {
    logger.info('Local database content NOT FOUND');
    return {
      hasChromeModelsLocalDatabaseContent: hasChromeModelsLocalDatabaseContent,
    };
  }

  try {
    const ChromeModelsLocalDatabaseContent = await readChromeModelClientDatabase();
    logger.debug(ChromeModelsLocalDatabaseContent, 'Local database content FOUND');
    return {
      models: Boolean(ChromeModelsLocalDatabaseContent.length) ? ChromeModelsLocalDatabaseContent : {},
    };
  } catch (error) {
    logger.error(error, 'Local database content NOT FOUND');
    return {
      models: {},
    };
  }
};
